import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components
import Button from "components/CustomButtons/Button.js";
import Tooltip from "@mui/material/Tooltip";
import Add from "@mui/icons-material/Add";


import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";

import styles from "../ServicesSections.module.scss";
export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );

  return (
    <div className={classes.section} style = {{ padding: "0px" }} >
      <GridContainer alignItems="center" spacing={8} style = {{ padding : "0px" }}  >

      
        <GridItem xs={12} sm={10} md={10} lg={10}>  

          <h2 className={classes.title}>No online strategy is complete without Google Ads</h2>
          <p>
          No online strategy is complete without Google Ads. We're your profit-focussed Google Ads experts. We are a google ads agency 
            that has 
             helped 
            small and large companies with budgets exceeding $30,000,000 turn their wasteful ad spend into sustained 
            profitability. Let us help you do the same. <br /><br />
            Australians spent <strong>992 million hours</strong> Googling in 2023. Don’t miss out on tapping into this huge market of ready-to-buy prospects.

            Google Ads is the most <strong>popular and fastest</strong> way to generate leads. It’s also complex and time-consuming.

            That’s why we’ve assembled a <strong>team of experts</strong> to manage your complex Google Ads campaigns. We specialise in helping you make sense of your marketing data, so you can generate revenue within your specific marketing budget.            <br /> <br /> 
            
          
          </p>
          
          <h2 className={classes.title}>Tribalism's view on Google Ads</h2>
          <h3 className={classes.title}>1. Google Ads are taking up all the top of page real estate</h3>
          <p>
            In many respects, Google Ads is a necessary thing. Ideally you'd rank #1 organically and not need to rely on buying google ads.
            But the reality is the Google ads now take up the first 4 ranking slots on many search results. Add in a location map and the first
             organic result can often appear below the fold!
          </p>
          <img
                  src="/img/services/images/google-ads-search-results.png"
                  alt="..."
                  className={imgClasses}
                />
                 <br/>
                 <br/>
                 <GridContainer justifyContent="center">
                <i>
                  People need to scroll past a lot of ads before they get to an organic result. Can you afford not to be there? A necessary thing.
                  
                </i>
                </GridContainer>
                

                  <h3 className={classes.title}>2. You will lose money and have no impact doing it half-heartedly. Google Ads are very complex to manage.</h3>
                  <p>
            Given businesses need to be there, they often do so grudgingly and try to get their ads up at <strong>minimum effort </strong>
             and <strong>minimum cost</strong>. In our experience this is dangerous! Yes you can rush up some campaigns and let them run...
             but there will be many unforeseen issues. Google Ads is not cheap - if you get the wrong people clicking on your ads, you 
             still have to pay for them. Even if they leave your site immediately after landing there, it doesnt matter! Wasted budget is a huge problem. 
             <br /><br />
             That's only one issue. The setup, ongoing management and ongoing strategy of google ads - is extremely complex! Here are some things you need to consider:
             <br /><br />
             </p>
             <ul>
             <li>
                <strong>Responsive Search Ads</strong> - Google no longer uses Expanded Text Ads. This means you need to have 15 different headlines to achieve a high Ad Quality. 
                Why is high ad quality important? It is a component of quality score. Why is quality score important? If you have a 
                low quality score your ad 'wont be shown' ... or you'll have to pay exorbitant costs to get them shown.
              </li>
              <li>
              <strong>What are your competitors doing?</strong> - have your costs gone through the roof? What is going on? Is there a new competitor in the market? 
                 Are your current competitors outperforming you? In what way s are they ourperforming you?
              </li>
              <li>
             <strong>Conversions/Strategy</strong> - have you set up conversions? Do you have offline conversions? Are you importing these? What bid strategy are you using? Maximise conversions? Target CPA? What figure should you be using for Target CPA?
              </li>
             <li>
             <strong>Locations</strong> - what cities, countries? what radius do you want to consider? Do you want to include people in or interested in your location. Generally not, yet this is the google default! You need to turn this off.
              </li>
              <li>
              <strong>Call Extensions</strong> - you need to verify your business on Google My Business first beofre you can add a phone numebr to your ads! How is your current GMB looking? 
              </li>
              <li>
              <strong>Ad Schedules</strong> - what days/times do you want to show your ads? Have you set up an ad schedule? 
              </li>
              <li>
              <strong>Ages/Gender/Interest Groups</strong> - do you want to factor in these demographics/features to your campaigns?
              </li>
              <li>
              <strong>Google Search Partners</strong> - do you want to be shown on the likes of ebay also? Google Ads defaults to have search partners like eBay turned on!
              </li>
              <li>
              <strong>Display/Youtube</strong> - do you want your search ads appearing here as 'display ads'? Having these on is also the default setting by Google, you need to turn these off manually.
              </li>
              <li>
              <strong>Business Logos</strong> - you need to make sure these are the right size, right quality, right visibility - google has very strict requirements here
              </li>
              <li>
              <strong>Sitelinks</strong> - 35 character limit per each description. Are all your links working? Are they relevant to this campaign? You dont want to spray and pray these when the competitition is tight.
              </li>
              <li>
              <strong>Sheer number of campaigns, ads and ad groups</strong> - you can only set locations at campaign level - so for every different 
              location that you want to target 
             with different messaging eg "plumbing services sydney!" you need to have a different campaign!! Think about how many campaigns, 
             ad groups and ads you need for all the keywords and services you provide or are interested in. For even moderate accounts you need 
             hundreds, often thousands!
              </li>
              
             </ul>


<p>All of these factors and more combine to make search engine ads <strong>very complex </strong>to manage for any account above the most basic of levels - ie 95% of cases!</p>
             <h3 className={classes.title}>3. Offshore Managers are a big risk!</h3>
             <p>Many local australian companies will offer google ads services... and then  offshore everything to cheaper workers. Even if this gets you a much cheaper rate, 
              it is nowhere near enough to make up for the lost revenue from mistakes and missing campaign targets completely. In the vast majority 
              of cases, cheaper low skilled workers for very complex tasks like search engine marketing management will <strong>cost you dearly</strong>.
             </p>
             <p>It *is* possible to integrate off shore resources into successful search campaign management, but you need well trained staff and very close communication and oversite from local staff to achieve decent results. Other factors include different timezones and cultural considerations - the way ads are written are crucial to their success. 
             </p>
             <p>Which is why, if you want the best campaign management you need local staff working on them. This is what Tribalism delivers. Local staff and the most experienced data people in the field. 
             </p>
            
             <p><i><strong>Please note: Tribalism only accepts a limited book of SEM clients.</strong> We appreciate the complexities involved and request that clients 
             consider this and the resources required to do a good job here.</i> </p>
             <h2 className={classes.title}>What makes us different?</h2>
             <p> We are<strong> data & analytics experts</strong>. Check out our data services on our website or try <a href="/services/analytics-services">here </a> 
              for a specific overview of data and analytics expertise. 
              <br /><br />
              </p>
              <ul>
                <li>Managing data intensive tools is our bread and butter. Google Ads is now one of the most complex data tools out there.
                  </li>
                  <li>We use advanced scripts to report on and better manage accounts than grunt work alone. This means experts in javascript and connecting data platforms like BigQuery
                  </li>
                  <li>We understand statistics. We won't bombard you with unnecessary info. We speak when we need to and we font report 'fluff' results.
                  </li>
                  <li>We use AI tools... sparingly... and with heavy oversight from our experts to fine tune accounts.
                  </li>
                  <li>We regularly meet with our clients to understand the complexities of their market - they know their market better than us (initially 😀)
                  </li>
                  <li>In terms of tracking we are very comfortable with the most complex of setups involving offline conversions and linking them back to 
                    your google ad accounts. We regularly build advanced setups here to handle all kinds of use cases, e.g. Salesforce to Google Ads
                  </li>
                  </ul>

             <p> We are<strong> local and experienced</strong>. We don't know everything. And we know that. We won't promise you the earth and then shift 
             everything offshore. 
              <br /><br />
              </p>
              <ul>
                <li>We want to meet you face to face and understand your issues. We want to understand your market - it's the most crucial thing in achieving and maintaining successful campaigns. Search ads are now ultra competitive and you need to understand your battlefield
                  </li>
                  <li>We will regularly catch up with you, with our most experienced staff to cover off performance and updates that have been or need to be made to the account
                  </li>
                  
                  </ul>

             <p> We are<strong> web design experts</strong>. We have built websites in a variety of platforms, from wordpress, webflow, shopify, next.js, react and more. 
             The interplay of web-design and search engine marketing is very important, especially landing page experience and hence quality score. 
              <br /><br />
              </p>
              <ul>
                <li>We will recommend the pages you (may) need to build and why.
                  </li>
                  <li>If you need, we will build them for you - to an extremely high quality!
                  </li>
                  <li>We will set up all the tracking you need - see above.
                  </li>
                  
                  </ul>


        </GridItem>

        

      </GridContainer>

      
    </div>
  );
}